/**
 * 用户部门岗位
 */
import React from 'react';
import { UserCardAction } from './UserCardType';
export default function UserDeptTitle(props) {
    var partTimeTitleDeptInfo = props.partTimeTitleDeptInfo, status = props.status, triggerEvent = props.triggerEvent, hideUserCardModal = props.hideUserCardModal, userType = props.userType, currentPage = props.currentPage, contactRelationship = props.contactRelationship;
    console.log('currentPage===', currentPage, status, userType);
    var handleClickUserDept = function (item) {
        if (!item)
            return;
        // if(status === UserCardAction.Add || currentPage?.indexOf("/address_list") !== -1 || userType !== "3") return;
        if (status === UserCardAction.Add || userType !== '3')
            return;
        triggerEvent === null || triggerEvent === void 0 ? void 0 : triggerEvent('showDepartment', item);
        if (hideUserCardModal) {
            hideUserCardModal();
        }
    };
    return (React.createElement("div", null, partTimeTitleDeptInfo === null || partTimeTitleDeptInfo === void 0 ? void 0 : partTimeTitleDeptInfo.map(function (item, index) {
        return (React.createElement("div", { key: item.deptId + "-" + item.titleId },
            (item === null || item === void 0 ? void 0 : item.fullDeptName) && (React.createElement("div", { className: "usercard-item-content" },
                React.createElement("h5", { className: "usercard-item-title inner" }, "\u90E8\u95E8"),
                React.createElement("p", { onClick: function () { return handleClickUserDept(item); }, className: "usercard-item-desc " + (status === UserCardAction.Add || userType !== '3'
                        ? ''
                        : 'usercard-department-title') }, item === null || item === void 0 ? void 0 : item.fullDeptName))),
            !(contactRelationship === null || contactRelationship === void 0 ? void 0 : contactRelationship.isEnableAddFriend) && (item === null || item === void 0 ? void 0 : item.directLeaderName) && (React.createElement("div", { className: "usercard-item-content" },
                React.createElement("h5", { className: "usercard-item-title inner" }, "\u76F4\u5C5E\u4E0A\u7EA7"),
                React.createElement("p", { onClick: function () {
                        triggerEvent('openUserCard', item === null || item === void 0 ? void 0 : item.directLeaderId);
                    }, className: "usercard-item-desc usercard-department-title" }, item.directLeaderName || ''))),
            (item === null || item === void 0 ? void 0 : item.titleName) && (React.createElement("div", { className: "usercard-item-content" },
                React.createElement("h5", { className: "usercard-item-title inner" }, "\u804C\u52A1"),
                React.createElement("p", { className: "usercard-item-desc" }, item.titleName))),
            (item === null || item === void 0 ? void 0 : item.telephone) && status !== UserCardAction.Add && (React.createElement("div", { className: "usercard-item-content" },
                React.createElement("h5", { className: "usercard-item-title inner" }, "\u5EA7\u673A"),
                React.createElement("p", { className: "usercard-item-desc" }, item.telephone)))));
    })));
}
//# sourceMappingURL=UserDeptTitle.js.map